import React, { ReactNode } from "react";
import { FormControlLabel, Switch } from "@mui/material";

interface CustomSwitchComponentProps {
    label?: ReactNode;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    disabled?: boolean;
    checked?: boolean;
    testId?: string;
}

const CustomSwitchComponent: React.FunctionComponent<CustomSwitchComponentProps> = ({ label, onChange, disabled = false, checked = false, testId }) => (
    <FormControlLabel control={<Switch data-testid={testId} color="primary" onChange={onChange} disabled={disabled} checked={checked} />} label={label} labelPlacement="start" />
);

export default CustomSwitchComponent;
